import axiosClient from "./axiosClient"; // Import the Axios client

// Create a new user
export const createUser = async (userData) => {
    try {
        const response = await axiosClient.post("/auth/register", userData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data; // Return API response
    } catch (error) {
        console.error("Error creating user:", error.response?.data || error.message);
        throw error;
    }
};

export const loginUser = async (userData) => {
    try {
        const response = await axiosClient.post("/auth/login", userData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data; // Return API response
    } catch (error) {
        console.error("Error creating user:", error.response?.data || error.message);
        throw error;
    }
};

// Get all user
export const getUsers = async () => {
    try {
        const response = await axiosClient.get("/user/all"); // Token is automatically added
        return response.data;
    } catch (error) {
        console.error("Error fetching user:", error.response?.data || error.message);
        throw error;
    }
};

export const getDrivers = async () => {
    try {
        const response = await axiosClient.get("/user/drivers"); // Token is automatically added
        return response.data;
    } catch (error) {
        console.error("Error fetching user:", error.response?.data || error.message);
        throw error;
    }
};

// Get a user by ID
export const getUserById = async (id) => {
    try {
        const response = await axiosClient.get(`/user/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching user:", error.response?.data || error.message);
        throw error;
    }
};

// Update user by ID
export const updateUser = async (id, userData) => {
    try {
        const response = await axiosClient.patch(`/user/${id}`, userData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating user:", error.response?.data || error.message);
        throw error;
    }
};

// Update user by ID
export const toggleUserStatus = async (userData) => {
    try {
        const response = await axiosClient.patch(`/user/toggle-status`, userData, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating user:", error.response?.data || error.message);
        throw error;
    }
};

// Delete user by ID
export const deleteUser = async (id) => {
    try {
        const response = await axiosClient.delete(`/user/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting user:", error.response?.data || error.message);
        throw error;
    }
};


export const updateRoles = async (data) => {
    try {
        const response = await axiosClient.patch(`/user/roles`, data, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating user:", error.response?.data || error.message);
        throw error;
    }
};

export const getRoles = async () => {
    try {
        const response = await axiosClient.get(`/user/roles`, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating user:", error.response?.data || error.message);
        throw error;
    }
};

// Get user preferences
export const getUserPreferences = async () => {
    try {
        const response = await axiosClient.get("/user/preferences");
        return response.data;
    } catch (error) {
        console.error("Error fetching preferences:", error.response?.data || error.message);
        throw error;
    }
};

// Update user preferences
export const updateUserPreferences = async (preferences) => {
    try {
        const response = await axiosClient.patch("/user/preferences", { preferences }, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error updating preferences:", error.response?.data || error.message);
        throw error;
    }
};